import colors from '../../../common/colors';

const style = {
  modalBackground: {
    backgroundColor: colors.white,
    display: 'flex',
    flexDirection: 'column',
    padding: '20px',
    borderRadius: '5px',
    margin: '0px 20px',
  },
  modalTitle: {
    fontSize: '20px',
    fontWeight: '600',
    color: colors.grey_200,
  },
};

export default style;
